import angular from 'angular';
import LoanDependant from './loanDependant';

export default angular
  .module('components.loanDependant', [])
  .component('loanDependant', LoanDependant).name;
